var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TasksToOwnTableComponent  DataTables"},[_c('div',{attrs:{"id":_vm.id}},[(!_vm.isData)?_c('LoaderComponent'):_vm._e()],1),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de710a72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TasksToOwnTableComponent.vue
// module id = null
// module chunks = 